module.exports = __webpack_public_path__ + "img/public/SiteIcons/Refresh.svg?48b19a87";